import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
import { ShieldIcon } from 'lucide-react';
export function Footer() {
  const [open, setOpen] = useState<'privacy' | 'terms' | null>(null);
  return <footer className="bg-navy py-8 md:py-12 border-t border-white/5" data-id="element-69">
      <div className="max-w-5xl mx-auto px-4 md:px-12" data-id="element-70">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:gap-6" data-id="element-71">
          {/* Brand */}
          <div className="flex items-center gap-2 text-gold" data-id="element-72">
            <ShieldIcon className="w-5 h-5" data-id="element-73" />
            <span className="font-playfair font-semibold text-base md:text-lg" data-id="element-74">
              El Protocolo del Retiro Blindado
            </span>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm" data-id="element-75">
            <button onClick={() => setOpen('privacy')} className="text-gray-light hover:text-gold transition-colors" data-id="element-76">
              Política de Privacidad
            </button>
            <button onClick={() => setOpen('terms')} className="text-gray-light hover:text-gold transition-colors" data-id="element-77">
              Términos de Uso
            </button>
          </div>
        </div>

        <div className="mt-6 md:mt-8 pt-6 border-t border-white/5 text-center text-gray-dark text-xs md:text-sm" data-id="element-78">
          © {new Date().getFullYear()} El Protocolo del Retiro Blindado. Todos
          los derechos reservados.
        </div>
      </div>

      <LegalModal isOpen={open === 'privacy'} onClose={() => setOpen(null)} title="Política de Privacidad" data-id="element-79">
        <PrivacyContent data-id="element-80" />
      </LegalModal>

      <LegalModal isOpen={open === 'terms'} onClose={() => setOpen(null)} title="Términos de Uso" data-id="element-81">
        <TermsContent data-id="element-82" />
      </LegalModal>
    </footer>;
}
function PrivacyContent() {
  return <div className="space-y-5 text-gray-light text-sm md:text-base leading-relaxed" data-id="element-83">
      <p className="text-xs text-gray-dark" data-id="element-84">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <section data-id="element-85">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-86">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-87">
          En El Protocolo del Retiro Blindado recopilamos información personal
          que tú nos proporcionas voluntariamente al agendar una sesión de
          asesoría, incluyendo: nombre completo, correo electrónico, número
          telefónico, edad, profesión, nivel de ingresos aproximado y metas
          financieras.
        </p>
      </section>

      <section data-id="element-88">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-89">
          2. Uso de la Información
        </h3>
        <p data-id="element-90">Utilizamos tus datos personales exclusivamente para:</p>
        <ul className="list-disc list-inside mt-2 space-y-1" data-id="element-91">
          <li data-id="element-92">Contactarte para confirmar y dar seguimiento a tu asesoría.</li>
          <li data-id="element-93">
            Diseñar una propuesta de blindaje patrimonial acorde a tu perfil.
          </li>
          <li data-id="element-94">
            Enviarte información relevante sobre productos de Seguros Monterrey
            New York Life.
          </li>
          <li data-id="element-95">
            Cumplir con las obligaciones legales y regulatorias aplicables.
          </li>
        </ul>
      </section>

      <section data-id="element-96">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-97">
          3. Protección de Datos
        </h3>
        <p data-id="element-98">
          Tus datos personales están protegidos conforme a la Ley Federal de
          Protección de Datos Personales en Posesión de los Particulares
          (LFPDPPP) de México. Implementamos medidas técnicas, administrativas y
          físicas para resguardar tu información contra accesos no autorizados.
        </p>
      </section>

      <section data-id="element-99">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-100">
          4. Compartir Información con Terceros
        </h3>
        <p data-id="element-101">
          Tu información podrá ser compartida únicamente con Seguros Monterrey
          New York Life y con el agente de seguros asignado a tu caso, con el
          fin exclusivo de diseñar e implementar tu plan de blindaje
          patrimonial. No vendemos ni rentamos tus datos a terceros.
        </p>
      </section>

      <section data-id="element-102">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-103">5. Derechos ARCO</h3>
        <p data-id="element-104">
          Tienes derecho a Acceder, Rectificar, Cancelar u Oponerte (Derechos
          ARCO) al tratamiento de tus datos personales en cualquier momento.
          Para ejercer estos derechos, contáctanos a través del correo de
          soporte del asesor que te atendió.
        </p>
      </section>

      <section data-id="element-105">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-106">
          6. Cookies y Tecnologías de Rastreo
        </h3>
        <p data-id="element-107">
          Este sitio utiliza cookies y píxeles de rastreo (incluyendo Meta
          Pixel) para medir la eficacia de nuestras campañas publicitarias y
          mejorar la experiencia del usuario. Puedes desactivar las cookies
          desde la configuración de tu navegador.
        </p>
      </section>

      <section data-id="element-108">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-109">7. Modificaciones</h3>
        <p data-id="element-110">
          Nos reservamos el derecho de actualizar esta Política de Privacidad en
          cualquier momento. Te recomendamos revisarla periódicamente.
        </p>
      </section>
    </div>;
}
function TermsContent() {
  return <div className="space-y-5 text-gray-light text-sm md:text-base leading-relaxed" data-id="element-111">
      <p className="text-xs text-gray-dark" data-id="element-112">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <section data-id="element-113">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-114">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-115">
          Al acceder y utilizar este sitio web, aceptas estos Términos de Uso en
          su totalidad. Si no estás de acuerdo con alguna parte de los términos,
          te pedimos no utilizar este sitio.
        </p>
      </section>

      <section data-id="element-116">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-117">
          2. Naturaleza del Servicio
        </h3>
        <p data-id="element-118">
          El Protocolo del Retiro Blindado es una plataforma de asesoría
          patrimonial que ofrece información educativa y sesiones de consultoría
          gratuitas para evaluar si el perfil del usuario califica para
          productos de seguro y ahorro de Seguros Monterrey New York Life.
        </p>
      </section>

      <section data-id="element-119">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-120">
          3. No Constituye Garantía Financiera
        </h3>
        <p data-id="element-121">
          Las proyecciones, ejemplos y testimonios presentados en este sitio son
          ilustrativos. Los resultados reales dependen de múltiples factores
          incluyendo edad, género, salud, plazo de contratación y condiciones
          del producto. Cualquier garantía contractual proviene exclusivamente
          de Seguros Monterrey New York Life conforme a la póliza firmada.
        </p>
      </section>

      <section data-id="element-122">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-123">
          4. Información Fiscal
        </h3>
        <p data-id="element-124">
          Las referencias a artículos de la Ley del Impuesto Sobre la Renta
          (Art. 93, 151, 185 LISR) son informativas. La deducibilidad efectiva
          depende del perfil fiscal individual del contribuyente. Recomendamos
          consultar a un contador autorizado.
        </p>
      </section>

      <section data-id="element-125">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-126">
          5. Propiedad Intelectual
        </h3>
        <p data-id="element-127">
          Todo el contenido de este sitio (textos, imágenes, videos, logos,
          gráficos) es propiedad de El Protocolo del Retiro Blindado o se
          utiliza con autorización. Queda prohibida su reproducción total o
          parcial sin consentimiento por escrito.
        </p>
      </section>

      <section data-id="element-128">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-129">
          6. Limitación de Responsabilidad
        </h3>
        <p data-id="element-130">
          No nos hacemos responsables por decisiones financieras tomadas por el
          usuario basadas únicamente en la información publicada en este sitio.
          La asesoría personalizada se brinda únicamente durante la sesión
          agendada con el asesor.
        </p>
      </section>

      <section data-id="element-131">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-132">
          7. Enlaces a Terceros
        </h3>
        <p data-id="element-133">
          Este sitio puede contener enlaces a servicios de terceros como
          Calendly y Wistia. No nos hacemos responsables del contenido ni de las
          prácticas de privacidad de dichos sitios.
        </p>
      </section>

      <section data-id="element-134">
        <h3 className="text-white font-bold text-lg mb-2" data-id="element-135">
          8. Legislación Aplicable
        </h3>
        <p data-id="element-136">
          Estos Términos de Uso se rigen por las leyes de los Estados Unidos
          Mexicanos. Cualquier controversia será resuelta ante los tribunales
          competentes de México.
        </p>
      </section>
    </div>;
}